// table const

// main table options
export const table_options = {
    download: false,
    filter: false,
    search: false,
    selectableRows: 'none'
}